// Registro declarativo de las operaciones.
//
// De este array salen el navbar, las rutas del router, el control de permisos y
// el payload de auditoría. Agregar una operación nueva son tres cosas: su
// calculo.js, su pantalla.html y una entrada acá. No hay que tocar el router, ni
// el navbar, ni la API (Accion es texto libre y Detalle es JSON).
//
// El `pid` es el id del permiso en LCApii, sistema 3.

import * as acreditacion from "./acreditacion/calculo.js";
import * as borrado from "./borrado/calculo.js";
import * as cierreCaja from "./cierre-caja/calculo.js";
import * as cuentaCorriente from "./cuenta-corriente/calculo.js";
import * as derivacion from "./derivacion/calculo.js";
import * as descGerencial from "./desc-gerencial/calculo.js";
import * as descuento from "./descuento/calculo.js";
import * as excedentes from "./excedentes/calculo.js";
import * as ingresoEgreso from "./ingreso-egreso/calculo.js";
import * as vacaciones from "./vacaciones/calculo.js";

import pantallaAcreditacion from "./acreditacion/pantalla.html?raw";
import pantallaBorrado from "./borrado/pantalla.html?raw";
import pantallaCierreCaja from "./cierre-caja/pantalla.html?raw";
import pantallaCuentaCorriente from "./cuenta-corriente/pantalla.html?raw";
import pantallaDerivacion from "./derivacion/pantalla.html?raw";
import pantallaDescGerencial from "./desc-gerencial/pantalla.html?raw";
import pantallaDescuento from "./descuento/pantalla.html?raw";
import pantallaExcedentes from "./excedentes/pantalla.html?raw";
import pantallaIngresoEgreso from "./ingreso-egreso/pantalla.html?raw";
import pantallaVacaciones from "./vacaciones/pantalla.html?raw";

export const OPERACIONES = [
  {
    clave: "acreditacion",
    titulo: "Acreditación",
    icono: "fa-receipt",
    pid: 13,
    accion: "Acreditacion",
    plantilla: pantallaAcreditacion,
    calculo: acreditacion,
    selects: [],
    fechas: ["Fecha"],
    leer: (v) => ({
      tipoFactura: v("TipoFactura"),
      fecha: v("Fecha"),
      puesto: v("Puesto"),
      nroFactura: v("NroFactura"),
    }),
  },
  {
    clave: "borrado",
    titulo: "Borrado",
    icono: "fa-trash",
    pid: 8,
    accion: "Borrado",
    plantilla: pantallaBorrado,
    calculo: borrado,
    selects: [{ id: "Sucursal", origen: "sucursales" }],
    sucursalPrincipal: "Sucursal",
    leer: (v) => ({ hora: v("Hora"), sucursal: v("Sucursal") }),
  },
  {
    clave: "cierre-caja",
    titulo: "Cierre Caja",
    icono: "fa-cash-register",
    pid: 9,
    accion: "Cierre-Caja",
    plantilla: pantallaCierreCaja,
    calculo: cierreCaja,
    selects: [{ id: "Sucursal", origen: "sucursales" }],
    sucursalPrincipal: "Sucursal",
    leer: (v) => ({ hora: v("Hora"), sucursal: v("Sucursal") }),
  },
  {
    clave: "cuenta-corriente",
    titulo: "Cuenta Corriente",
    icono: "fa-file-invoice-dollar",
    pid: 14,
    accion: "Cuenta-Corriente",
    plantilla: pantallaCuentaCorriente,
    calculo: cuentaCorriente,
    selects: [{ id: "Sucursal", origen: "sucursales" }],
    sucursalPrincipal: "Sucursal",
    fechas: ["Fecha"],
    leer: (v) => ({
      sucursal: v("Sucursal"),
      fecha: v("Fecha"),
      cliente: v("Cliente"),
      tipoDocumento: v("TipoDocumento"),
      importe: v("Importe"),
    }),
  },
  {
    clave: "derivacion",
    titulo: "Derivación",
    icono: "fa-arrow-right-arrow-left",
    pid: 10,
    accion: "Derivacion",
    plantilla: pantallaDerivacion,
    calculo: derivacion,
    // Cada select se llena con su propia lista de sucursales permitidas, que
    // vienen en datosUsuario de LCApii.
    selects: [
      { id: "SucursalO", origen: "derivacionOrigen" },
      { id: "SucursalD", origen: "derivacionDestino" },
    ],
    sucursalPrincipal: "SucursalO",
    leer: (v) => ({
      tipoFactura: v("TipoFactura"),
      puesto: v("Puesto"),
      nroFactura: v("NroFactura"),
      sucursalOrigen: v("SucursalO"),
      sucursalDestino: v("SucursalD"),
    }),
  },
  {
    clave: "desc-gerencial",
    titulo: "Desc. Gerencial",
    icono: "fa-user-tie",
    pid: 12,
    accion: "Descuento-Gerencial",
    plantilla: pantallaDescGerencial,
    calculo: descGerencial,
    selects: [{ id: "Sucursal", origen: "sucursales" }],
    sucursalPrincipal: "Sucursal",
    leer: (v) => ({ nroSolicitud: v("nroSolicitud"), sucursal: v("Sucursal") }),
  },
  {
    clave: "descuento",
    titulo: "Descuento",
    icono: "fa-tag",
    pid: 7,
    accion: "Descuento",
    plantilla: pantallaDescuento,
    calculo: descuento,
    selects: [{ id: "Sucursal", origen: "sucursales" }],
    sucursalPrincipal: "Sucursal",
    leer: (v) => ({ nroSolicitud: v("nroSolicitud"), sucursal: v("Sucursal") }),
  },
  {
    clave: "excedentes",
    titulo: "Excedentes",
    icono: "fa-boxes-stacked",
    pid: 11,
    accion: "Excedentes",
    plantilla: pantallaExcedentes,
    calculo: excedentes,
    selects: [{ id: "Sucursal", origen: "sucursales" }],
    sucursalPrincipal: "Sucursal",
    leer: (v) => ({
      sucursal: v("Sucursal"),
      cantItems: v("cantItems"),
      cantExcedentes: v("cantExcedentes"),
    }),
  },
  {
    clave: "ingreso-egreso",
    titulo: "Ingreso / Egreso",
    icono: "fa-money-bill-transfer",
    pid: 30,
    accion: "Ingreso-Egreso",
    plantilla: pantallaIngresoEgreso,
    calculo: ingresoEgreso,
    selects: [{ id: "Sucursal", origen: "sucursales" }],
    sucursalPrincipal: "Sucursal",
    leer: (v) => ({
      tipo: v("Tipo"),
      nroComprobante: v("NroComprobante"),
      importe: v("Importe"),
      sucursal: v("Sucursal"),
    }),
  },
  {
    clave: "vacaciones",
    titulo: "Vacaciones",
    icono: "fa-umbrella-beach",
    pid: 29,
    accion: "Vacaciones",
    plantilla: pantallaVacaciones,
    calculo: vacaciones,
    // Sin sucursal: la habilitación es por legajo.
    selects: [],
    leer: (v) => ({ solicitud: v("solicitud") }),
  },
];

export const operacionPorClave = (clave) => OPERACIONES.find((o) => o.clave === clave) || null;
